export function isNullOrUndefined(val: any) {
  return val === null || val === undefined;
}